var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-header py-4 animate-slide-from-above"},[_c('img',{staticClass:"logo mb-4",attrs:{"src":_vm.bannerSrc,"alt":_vm.translations.ewi}}),_vm._v(" "),_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }